const tagsInputIpFieldValidation = {
  required: 'Field is required',
  invalidAddressFormat: 'Invalid address format',
  invalidCidr: "{cidr} isn't valid entry",
};

export const settingsGlobalDiscoveryConfigurationMessages = {
  en: {
    tabs: {
      certificate: 'IP FABRIC Certificate',
      system: 'System',
      snmp: 'SNMP',
      jumphost: 'Jumphost',
      deviceAttributes: 'Device attributes',
      oui: 'OUI',
    },
    title: 'Settings',
    jumphost: {
      btnAdd: 'Add',
      btnEdit: 'Edit',
      btnDownload: 'Download public key',
      btnUpdate: 'Update',
      btnClose: 'Close',
      yes: 'Yes',
      no: 'No',
      running: 'Running',
      inactive: 'Inactive',
      deleteJumphostConfirmDialog: {
        header:
          '{count, plural, one {Jumphost} other {# Jumphosts}} will be deleted',
        subHeader:
          'Delete {count, plural, one {jumphost} other {# jumphosts}}?',
      },
      columns: {
        action: 'Action',
      },
      form: {
        addTitle: 'Add Jumphost',
        editTitle: 'Edit Jumphost {name}',
        enabled: 'Enabled',
        disabled: 'Disabled',
        label: 'Label',
        address: 'Jumphost Address',
        port: 'Port',
        subnets: 'IPv4 subnets',
        subnetsTooltip:
          'If you use 0.0.0.0/0 or another subnet which includes your network from which you are connecting to IP Fabric, make sure you put your network to “Exclude IPv4 subnet”. Otherwise, your IP connection will be lost and you will have to recover from the console.',
        exclude: 'Exclude IPv4 subnets',
        subnetsPlaceholer: 'Add CIDR',
        loginType: 'Login type',
        username: 'Username',
        password: 'Password',
        loginTypeOptions: {
          credentials: 'Use credentials',
          'ssh-key': 'Use SSH key',
        },
        validation: {
          ...tagsInputIpFieldValidation,
          portRange: 'Port has to be 1-65535',
        },
      },
      request: {
        saveSuccess: 'Jumphost saved',
        updateSuccess: 'Jumphost updated',
        deleteJumphostSuccess: 'Jumphost deleted',
        deleteJumphostsSuccess: 'Jumphosts deleted',
        resourceConflict:
          "Can't save, the jumphost address {address} is already saved.",
      },
    },
  },
};
